"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructFullName = exports.toTitleCase = exports.camelCase_to_Sentence = exports.toCamelCase = exports.capitalize = exports.noSpace = exports.camelToDisplay = void 0;
var core_services_1 = require("@iotv/core-services");
Object.defineProperty(exports, "camelToDisplay", { enumerable: true, get: function () { return core_services_1.camelToDisplay; } });
Object.defineProperty(exports, "noSpace", { enumerable: true, get: function () { return core_services_1.noSpace; } });
Object.defineProperty(exports, "capitalize", { enumerable: true, get: function () { return core_services_1.capitalize; } });
Object.defineProperty(exports, "toCamelCase", { enumerable: true, get: function () { return core_services_1.toCamelCase; } });
Object.defineProperty(exports, "camelCase_to_Sentence", { enumerable: true, get: function () { return core_services_1.camelCase_to_Sentence; } });
Object.defineProperty(exports, "toTitleCase", { enumerable: true, get: function () { return core_services_1.toTitleCase; } });
/** Takes a node and a nem and constructs a full name based on "parent / parent / node" using links found in nem
 * e.g. property1 -> area1 -> area2
 *  - area2 returns "property1 / area1 / area2"
 *  - area1 returns "property1 / area1"
 *
 * @param node - The node who's name to get. Always included
 * @param nem - THe node edge mapper containing relationships to construct the name by
 * @param typeFilter - Optional filter on types of parent. Base node always included
 * @returns A constructed full name of the node of the form "parent / node"
 * */
const constructFullName = (node, nem, typeFilter) => {
    let parentNodes = nem.getAscendents([node]);
    let nodesForName = [node];
    let fullName = '';
    for (let i = parentNodes.length - 1; i >= 0; i--) {
        const n = parentNodes[i];
        if (typeFilter && !typeFilter.includes(n.type))
            break;
        nodesForName.unshift(n);
    }
    fullName = nodesForName.map((n) => n.name).join(' / ');
    return fullName;
};
exports.constructFullName = constructFullName;
